import { colonyAPI } from '@/api';
import * as types from './mutation-types';

export default {
  getPlugins({ commit }) {
    commit(types.GET_PLUGINS_REQUEST);
    colonyAPI.get('plugins/')
      .then(response => commit(types.GET_PLUGINS_SUCCESS, response.data))
      .catch(error => commit(types.GET_PLUGINS_FAILURE, error));
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/plugin/actions.js